import { Close } from "@mui/icons-material";
import { Box, IconButton, Skeleton, Typography } from "@mui/material";

import { ServiceConnectionModel } from "../../../api/api";
import ServiceConnectionStatusChip from "../../ServiceConnections/ServiceConnectionStatusChip";

interface ServiceConnectionDisplayProps {
	serviceConnection: ServiceConnectionModel | null;
	serviceConnectionId?: string;
	serviceConnectionType?: string;
	isLoading?: boolean;
	onUnlink?: () => void;
	isUnlinking?: boolean;
	showUnlinkButton?: boolean;
}

export default function ServiceConnectionDisplay({
	serviceConnection,
	serviceConnectionId,
	serviceConnectionType,
	isLoading = false,
	onUnlink,
	isUnlinking = false,
	showUnlinkButton = false,
}: ServiceConnectionDisplayProps) {
	if (isLoading) {
		return (
			<Box sx={{ p: 2 }}>
				<Skeleton variant="text" width={150} height={20} />
				<Skeleton variant="text" width={100} height={16} sx={{ mt: 0.5 }} />
			</Box>
		);
	}

	return (
		<Box sx={{ display: "flex", width: "100%", alignItems: "center", p: showUnlinkButton ? 0 : 2 }}>
			<Box sx={{ flexGrow: 1, minWidth: 0 }}>
				<Typography variant="body2" sx={{ fontWeight: "medium", wordBreak: "break-word", mb: 0.5 }}>
					{serviceConnection?.name || serviceConnectionId || "Unknown"}
				</Typography>
				<Typography variant="caption" color="textSecondary">
					Type: {serviceConnection?.type || serviceConnectionType || "Unknown"}
				</Typography>
			</Box>
			{serviceConnection?.statusName && (
				<Box sx={{ ml: 2, flexShrink: 0 }}>
					<ServiceConnectionStatusChip status={serviceConnection.statusName} size="small" />
				</Box>
			)}
			<IconButton
				size="small"
				onClick={onUnlink}
				disabled={!showUnlinkButton || isUnlinking}
				title="Unlink service connection"
				sx={{ color: "error.main", ml: 1, flexShrink: 0 }}
			>
				<Close />
			</IconButton>
		</Box>
	);
}
